import React from "react";
import { Box, Typography, TextField, CircularProgress } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

export default function SingleSelect({
  placeholder,
  containerStyle,
  width,
  label,
  options,
  isLoading,
  onInputChange,
  onMenuScrollToBottom,
  onChange,
  value,
  getOptionValue,
  getOptionLabel,
  isMulti = false,
  error,
  isDisabled = false,
  props,
  noOfLines = 0.5,
}) {
  return (
    <Box width={width || "100%"} style={containerStyle}>
      {label && (
        <Typography marginBottom={2} fontWeight="500" fontSize={16}>
          {label}
        </Typography>
      )}
      <Autocomplete
        multiple={isMulti}
        options={options}
        getOptionLabel={(option) => getOptionLabel(option)}
        getOptionSelected={(option, value) =>
          getOptionValue(option) === getOptionValue(value)
        }
        value={value}
        onInputChange={(event, newInputValue) => onInputChange(newInputValue)}
        onChange={(event, newValue) => onChange(newValue)}
        disableClearable={!isMulti}
        disabled={isDisabled}
        loading={isLoading}
        ListboxProps={{
          style: {
            maxHeight: "300px",
            overflow: "auto",
          },
          onScroll: (event) => {
            const listboxNode = event.currentTarget;
            if (
              listboxNode.scrollHeight - listboxNode.scrollTop ===
              listboxNode.clientHeight
            ) {
              onMenuScrollToBottom && onMenuScrollToBottom();
            }
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={
              !value || (isMulti && value.length === 0)
                ? placeholder || label || "Search and select..."
                : ""
            }
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            inputProps={{
              ...params.inputProps,
              style: { maxHeight: `${noOfLines * 20}px`, overflow: "hidden" },
            }}
            error={!!error}
            helperText={error}
          />
        )}
        {...props}
      />
    </Box>
  );
}
